import React from 'react';
import { LayoutDashboardIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Emma Thompson',
  title: 'Interior Book Artist',
  specialties: ['Chapter Headers', 'Decorative Elements', 'Maps'],
  rating: 4.9,
  reviewCount: 127,
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$200-500'
}, {
  id: '2',
  name: 'Michael Chen',
  title: 'Book Interior Designer',
  specialties: ['Typography', 'Layout Design', 'Illustrations'],
  rating: 4.8,
  reviewCount: 93,
  imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$300-700'
}];
const InteriorArtists = () => <CreativeDirectoryPage title="Interior Book Artists" subtitle="Connect with talented artists who specialize in interior book design, from chapter headers to decorative elements" icon={<LayoutDashboardIcon className="h-8 w-8" data-id="element-9310" data-mp="35wgty9k4a676" />} profileBasePath="/creative/interior-artists" artists={artists} data-id="element-9309" data-mp="30zqcpiwkt4k6" />;
export default InteriorArtists;